import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  index(params) {
    const url = apiRoutes.administratorsLoanOfficersPath();

    return FetchHelpers.get(url, params);
  },

  show(id) {
    const url = apiRoutes.administratorsLoanOfficerPath(id);

    return FetchHelpers.get(url);
  },

  update(params) {
    const url = apiRoutes.administratorsLoanOfficersPath();

    return FetchHelpers.post(url, params);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/administrators/LoanOfficersRepository.js